module.exports = __webpack_public_path__ + "media/images/pc/plans/search_form/costume_type_both_costume@3x-f9b163867ddf8b7bf85a871af5e50df3.webp";